import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MustWatchEpisodesService } from './must-watch-episodes.service';
import { LOCALE_ID } from '@angular/core';

@Component({
  selector: 'app-must-watch-episodes',
  templateUrl: './must-watch-episodes.component.html',
  styleUrls: ['./must-watch-episodes.component.scss']
})
export class MustWatchEpisodesComponent implements OnInit {

  public learnVideos: any[] = [];
  public firstVideo: any;

  constructor(
    private content: MustWatchEpisodesService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.content.getAfroTechLearnVideos().subscribe((res: any) => {
      const rawVideos = res?.data || [];

      this.learnVideos = rawVideos.map((item: any) => {
        const attributes = item.attributes;
        const videoId = attributes.videoId;
        const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
      
        return {
          ...attributes,
          videoId,
          title: attributes.title,
          date: attributes.publishedAt || attributes.updatedAt,
          duration: attributes.duration || '~3 min',
          thumbnail,
        };
      });      

      if (this.learnVideos.length > 0) {
        const first = this.learnVideos[0];
        this.firstVideo = first;
      }
    });
  }

  isToday(date: string): boolean {
    const today = new Date();
    const inputDate = new Date(date);
    return inputDate.toDateString() === today.toDateString();
  }
}
